/**
 * Video Modal and Form Handlers for Astro
 */

/**
 * Formats phone number inputs to (XXX) XXX-XXXX pattern
 */
function initPhoneFormatting() {
    document.querySelectorAll('#avochato-number').forEach(input => {
        input.addEventListener('input', function() {
            let digits = this.value.replace(/\D/g, '').substring(0, 10);
            let formatted = '';
            
            if (digits.length > 0) {
                if (digits.length <= 3) {
                    formatted = `(${digits}`;
                } else if (digits.length <= 6) {
                    formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
                } else {
                    formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
                }
            }
            
            this.value = formatted;
        });
    });
}

/**
 * Handles form submissions for Avochato forms
 */
function initFormHandlers() {
    const avochatoForms = document.querySelectorAll('.avochato-form');
    
    avochatoForms.forEach(form => {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            
            const phoneInput = form.querySelector('.avochato-number');
            const phoneValue = phoneInput.value.trim();
            const formContainer = form.closest('#avochato-form'); // Get parent container
            const successMessage = formContainer.querySelector('.form-success');
            const errorMessage = formContainer.querySelector('.form-error');
            
            // Hide previous messages
            if (successMessage) successMessage.style.display = 'none';
            if (errorMessage) errorMessage.style.display = 'none';
            
            // Validate phone number (should have 10 digits)
            const digitsOnly = phoneValue.replace(/\D/g, '');
            if (!phoneValue || digitsOnly.length < 10) {
                if (errorMessage) errorMessage.style.display = 'block';
                return;
            }
            
            const request = new XMLHttpRequest();
            request.open('POST', 'https://events.hookdeck.com/e/src_0TAQ1mB5C99j');
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            
            request.onreadystatechange = function() {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        if (successMessage) successMessage.style.display = 'block';
                        phoneInput.value = ''; // Clear input on success
                    } else {
                        if (errorMessage) errorMessage.style.display = 'block';
                        console.log('Request failed:', this.status);
                    }
                }
            };
            
            const secretShopKeywordValue = form.querySelector('.avochato-secret-shop-keyword')?.value || false;
            
            request.send(JSON.stringify({
                phone: phoneValue,
                secret_shop_keyword: secretShopKeywordValue
            }));
        });
    });
}

/**
 * Handles all video modal functionality
 */
function initVideoModal() {
    const modal = document.getElementById('videoModal');
    if (!modal) return;
    
    // Helper functions
    const extractYouTubeId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    };
    
    const extractVimeoId = (url) => {
        const regExp = /vimeo\.com\/([0-9]+)/;
        const match = url.match(regExp);
        return match ? match[1] : null;
    };
    
    const stopVideo = (iframe) => {
        try {
            if (iframe.src.includes('youtube.com')) {
                iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
            } else if (iframe.src.includes('vimeo.com')) {
                iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
            } else {
                const video = iframe.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            }
        } catch (e) {
            console.log('Error stopping video:', e);
        }
    };
    
    const closeModal = () => {
        const iframe = modal.querySelector('iframe');
        stopVideo(iframe);
        iframe.src = '';
        modal.classList.remove('modal-open');
    };
    
    // Open modal handlers
    const openModalButtons = document.querySelectorAll('[data-open-video-modal]');
    openModalButtons.forEach(button => {
        button.addEventListener('click', () => {
            const iframe = modal.querySelector('iframe');
            const videoSrc = iframe.dataset.src;
            
            iframe.src = videoSrc;
            modal.classList.add('modal-open');
            
            setTimeout(() => {
                if (videoSrc.includes('youtube.com') || videoSrc.includes('youtu.be')) {
                    const videoId = extractYouTubeId(videoSrc);
                    if (videoId) {
                        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
                    }
                } else if (videoSrc.includes('vimeo.com')) {
                    const videoId = extractVimeoId(videoSrc);
                    if (videoId) {
                        iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
                    }
                } else if (videoSrc.match(/\.(mp4|webm|ogg|mov)$/i)) {
                    const video = iframe.querySelector('video');
                    if (video) {
                        video.play().catch(e => console.log('Auto-play prevented:', e));
                    }
                }
            }, 100);
        });
    });
    
    // Close modal handlers
    const closeModalButtons = document.querySelectorAll('[data-close-video-modal]');
    closeModalButtons.forEach(button => {
        button.addEventListener('click', closeModal);
    });
    
    // Click outside modal
    modal.addEventListener('click', (event) => {
        if (event.target === modal) {
            closeModal();
        }
    });
    
    // Escape key
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('modal-open')) {
            closeModal();
        }
    });
}

/**
 * Initialize all functionality
 */
document.addEventListener('DOMContentLoaded', () => {
    initPhoneFormatting();
    initVideoModal();
    
    // Delay form handlers to ensure elements are ready
    initFormHandlers();
});